/*
    © 2021 EcomGraduates.com. All rights reserved.
    https://www.ecomgraduates.com
*/

/*
    IMPORTANT: Through that you may directly work on this file,
    we recommend that you create a new JavaScript file
    "asset/custom.js" and add all your scripts there. In this way,
    it will be easier for you to update our theme.
*/

// Theme info in console
console.log('Custom Shopify Theme Developed By EcomGraduates LLC | https://www.ecomgraduates.com')


// Init Bootstrap tooltips
document.querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach((el) => new bootstrap.Tooltip(el));

// Init Bootstrap popovers
document.querySelectorAll('[data-bs-toggle="popover"]')
    .forEach((el) => new bootstrap.Popover(el));

// Autofocus on search field on offcanvas open
document.querySelector('#offcanvas-search')?.addEventListener('shown.bs.offcanvas', () => {
    document.querySelector('#predictive-search-input').focus();
});

// Shopify's callenge page - Add BS classes
document.querySelector('.btn.shopify-challenge__button')
    ?.classList.add('btn-primary');

// Shopify's errors message - Add BS classes
const errors = document.querySelector('.errors');
if (errors) {
    errors.classList.add('alert', 'alert-danger');
    errors.querySelector('ul').classList.add('mb-0');
}

// Scroll to newsletter form after submit
if (window.location.href.indexOf('?customer_posted=true') > -1) {
    setTimeout(() => {
        document.querySelector('.newsletter-form').scrollIntoView();
    }, 750);
}

// Carousel section
// Move to corresponding slide when clicking a section block in Shopify's theme editor
document.addEventListener('shopify:block:select', (e) => {
    const carouselEl = e.target.closest('.carousel');

    if (carouselEl) {
        const selectedSlide = e.target.dataset.index;
        bootstrap.Carousel.getOrCreateInstance(carouselEl, { interval: false }).to(selectedSlide);
    }
});

// Product list items animation
window.restartProductListItemsAnimation = () => {
    document.querySelectorAll('.product-list-item.animate__animated').forEach((el) => {
        el.classList.remove('opacity-0');
        el.classList.add(el.dataset.animateClass);
    });
};

// Detect when element is within the scroll view
// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
const initEnterViewAnimations = () => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                // console.log(entry)
                entry.target.classList.add('entered');
                entry.target.querySelectorAll('.animate__animated.opacity-0').forEach((el) => {
                    el.classList.remove('opacity-0');
                    el.classList.add(el.dataset.animateClass);
                });
            }
        });
    }, { threshold: 0, rootMargin: '0px 0px -200px 0px' });

    document.querySelectorAll('.enter-view').forEach((el) => {
        observer.observe(el);
    });
};
initEnterViewAnimations();

document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.enter-view').forEach((enterViewEl) => {
        enterViewEl.classList.add('entered');
        document.querySelectorAll('.animate__animated.opacity-0').forEach((el) => {
            el.classList.remove('opacity-0');
        });
    });
});

// Before/After Slider init
// https://image-compare-viewer.netlify.app/
document.querySelectorAll('.image-compare').forEach((el) => {
    new ImageCompare(el, {
        showLabels: true,
        labelOptions: {
            before: 'Before',
            after: 'After',
        },
        smoothing: false,
        hoverStart: true,
    }).mount();
});

// Reviews Slider in Offcanvas menu
const reviewsSliderSplide = document.querySelector('#offcanvas-menu-reviews .splide');

if (reviewsSliderSplide) {
    const splide = new Splide(reviewsSliderSplide, {
        arrows: false,
        autoplay: true,
    });
    splide.mount();
}

/**
 * Extract email from URL id parameter and save to localStorage
 * This function runs globally on all pages to capture emails from URL parameters
 * and save them for artwork form prefill functionality
 */
function extractEmailFromUrl() {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const emailFromUrl = urlParams.get('id');
        
        if (emailFromUrl && isValidEmail(emailFromUrl)) {
            // Save extracted email to localStorage for artwork form prefill
            localStorage.setItem('artwork_form_last_search', emailFromUrl);
            
            // Prefill old product form input if it exists and is empty
            prefillOldProductForm(emailFromUrl);
            
            // Dispatch event to notify other components about the email extraction
            window.dispatchEvent(new CustomEvent('artwork:url-email-extracted', { 
                detail: { email: emailFromUrl } 
            }));
            
            console.log('Email extracted from URL and saved to localStorage:', emailFromUrl);
        }
    } catch (error) {
        console.warn('Error extracting email from URL:', error);
    }
}

/**
 * Prefill old product form input with email from localStorage
 * This works for the legacy product form that doesn't use the artwork-form component
 * @param {string} email - Email to prefill
 */
function prefillOldProductForm(email) {
    try {
        const oldProductFormInput = document.querySelector('#product-form-input-order-no');
        if (oldProductFormInput && !oldProductFormInput.value) {
            oldProductFormInput.value = email;
            
            // Trigger input event to activate any existing artwork lookup logic
            const inputEvent = new Event('input', { bubbles: true });
            oldProductFormInput.dispatchEvent(inputEvent);
            
            console.log('Prefilled old product form input with email:', email);
        }
    } catch (error) {
        console.warn('Error prefilling old product form:', error);
    }
}

/**
 * Prefill artwork inputs from localStorage on page load
 * This function checks both new and old product forms
 */
function prefillArtworkInputsFromStorage() {
    try {
        const savedEmail = localStorage.getItem('artwork_form_last_search');
        if (savedEmail && isValidEmail(savedEmail)) {
            // Prefill old product form
            prefillOldProductForm(savedEmail);
            
            // The new artwork-form component will handle its own prefill via its lifecycle
            console.log('Attempted to prefill artwork inputs from localStorage:', savedEmail);
        }
    } catch (error) {
        console.warn('Error prefilling artwork inputs from localStorage:', error);
    }
}

/**
 * Validate email format
 * @param {string} email - Email to validate
 * @returns {boolean} Whether email is valid
 */
function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

// Run email extraction on page load
extractEmailFromUrl();

// Also prefill from localStorage if no URL email was found
setTimeout(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const emailFromUrl = urlParams.get('id');
    
    // Only prefill from localStorage if no email was extracted from URL
    if (!emailFromUrl || !isValidEmail(emailFromUrl)) {
        prefillArtworkInputsFromStorage();
    }
}, 100); 